module.exports = __webpack_public_path__ + "static/media/democrat.d265d45f.svg";